module.exports = __webpack_public_path__ + "static/media/508.b2d889e0.png";